"use client";

import { defaultHead } from "next/head";
import React, { useEffect, useState } from "react";
import styles from "./loginDialog.module.scss";
import { FaApple } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import LoginByEmail from "../ByEmail/ByEmail";
import LoginByPhone from "../ByPhone/ByPhone";
// import "./state.css";
import Signup from "../signup/signup";
import VerificationCode from "../verificationCode/verificationCode";
import VerificationWay from "../verificationWay/verificationWay";
import { useRouter, useSearchParams } from "next/navigation";
import { useLocation } from "@hooks/useLocation";
import Cookies from "js-cookie";
import { sendGTMEvent } from "@next/third-parties/google";
import SurveyForm from "@components/typeform/typeform";
import { getSurveyData, skipSurvey } from "@services/typeform";

export default function LoginDialog({ CloseLogin= () => {}, SuccessClose= ()=> {}, isRoute = false, eventID=""}) {
  const [ByEmail, setByEmail] = useState(false);
  const [data, setData] = useState();
  const [dataVerify, setDataVerify] = useState();
  const [action, setAction] = useState(""); 
  const [openForm, setOpenForm] = useState(false);
  const [startingAccount, setStartingAccount] = useState("");
  const [surveRes, setSurveyRes] = useState();
  const searchParams = useSearchParams();
  const router = useRouter();
  const utm_source = searchParams.get('utm_source'); 
  const [userId, setUserId] = useState();
  async function fetchIP() {
    const res = await fetch('/api/get-ip');
    const data = await res.json();
    console.log('Client IP:', data.ip);
  }
// console.log(location);

  useEffect(()=>{
    fetchIP();
  },[])
  const handleLoginSuccess = (data, token) => {
console.log(data);

    Cookies.set(
      "user",
      JSON.stringify({
        id: data.uid,
        email: data.email,
        idToken: token,
        refreshToken: token,
        fname: data.firstName,
        lastName: data.lastName,
        country: data.address,
        phoneNumber: data.phoneNumber,
        gender: data.gender,
        dob: data.dob,
        updatedFields: data.updatedFields,
        username: data.userName,
        isPhoneVerified: data.isPhoneVerified,
        isEmailVerified: data.isEmailVerified,
      } ),
      {
        expires: 365, // Keep cookie for 1 year
        secure: true, // Optional: only send over HTTPS
        sameSite: "Lax", // Optional: protects against CSRF in most cases
      }
    );
    sendGTMEvent({event: "login",
      user_data: {
        country: data.address,
        customer_id: data.uid, // user id
        email: data.email,
        first_name: data.firstName,
        last_name: data.lastName,
        phone: data.phoneNumber,
    }})
    Cookies.set("token", JSON.stringify(token),   {
      expires: 365, // Keep cookie for 1 year
      secure: true, // Optional: only send over HTTPS
      sameSite: "Lax", // Optional: protects against CSRF in most cases
    });
    Cookies.set(
      "tokens",
      JSON.stringify({
        idToken: token,
        refreshToken: token,
      }),   {
        expires: 365, // Keep cookie for 1 year
        secure: true, // Optional: only send over HTTPS
        sameSite: "Lax", // Optional: protects against CSRF in most cases
      }
    );
  };
  const handleAfterForm = () => {
        if (utm_source)
          router.push(`/payment/${eventID}?utm_source=${utm_source}`);
        else router.push(`/payment/${eventID}`);
  }

  async function handleRetrieveData(data, googleOrApple = false) {
    console.log(data);
    if(data.nextAction !== "COMPLETE-PROFILE-DATA") setData(data);
    if(data.nextAction === "COMPLETE-PROFILE-DATA") {
      if(googleOrApple) setData(data)
      setDataVerify(data);
    }
    if(data.nextAction === "VALIDATE-OTP") {
      if(data.method === "EMAIL") {
        setAction(data.nextAction);
      }
      if(data.method === "PHONE") {
        setAction(data.nextAction);
      }
    }
    console.log(data);
    if(data.nextAction === "SELECT-PHONE-METHOD") {
      if(data.method === "PHONE") {
        setAction(data.nextAction);
      }
      if(data.method === "EMAIL") {
        setAction(data.nextAction);
      }
    }
    if(data.nextAction === "COMPLETE-PROFILE-DATA")
      setAction(data.nextAction);
    if(data.nextAction === "CONTINUE") {
      // CloseLogin();
      console.log(data);
      
      try {
        const res = await getSurveyData(data.token, false);
        console.log(res);
        const { status, data: surveyData} = res;
        console.log(status);
        
        if(status === "success") {
          setSurveyRes(surveyData);
          console.log(surveyData);
          if(isRoute) {handleLoginSuccess(data.userData, data.token);
            setUserId(data.userData.uid);
            if(!surveyData.showSurvey) {
              handleAfterForm();
            }
          }
          else{
             SuccessClose(data.userData, data.token);
            setUserId(data.userData.uid);
            if(!surveyData.showSurvey) router.refresh();
            }
          if(surveyData.showSurvey) setOpenForm(true);
        }
        else {
        if(isRoute) {
          handleLoginSuccess(data.userData, data.token);
          handleAfterForm();
        }
        else {SuccessClose(data.userData, data.token);
          router.refresh();
        }

        }

      } catch (error) {
        console.error(error);
        if(isRoute) handleLoginSuccess(data.userData, data.token);
        else {
          SuccessClose(data.userData, data.token);
          router.refresh();
        }
      }
      // setOpenForm(true);

    }
  }
    const handleSkip = async () => {
      try {
        const res = await skipSurvey(data.token, surveRes.surveyID);
        console.log(res);
        if(res.status === "success") {
          if(isRoute) handleAfterForm();
          else router.refresh();
        }
      } catch (error) {
        console.error('Error skipping survey:', error);
      }
    };
  function handleForSubmit () {
          if (isRoute) handleAfterForm();
          else router.refresh();
  }
  function handleResendBack (email) {
    setData(null);
    setAction("")
    setByEmail(email);
  }
  async function fetchIPs() {
    const res = await fetch("/api/get-ip");
    const { ip } = await res.json();
    await handleSkip();
    console.log("Client IP on refresh (openForm):", ip);
    // …do whatever else you need…
  }


  // 1) when openForm becomes true, install beforeunload
  useEffect(() => {
    if (!openForm) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";

      // safe to write now that we know we’re in the browser
      sessionStorage.setItem("shouldFetchIPAfterReload", "1");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [openForm]);

  // 2) on first mount, if that flag is set, call fetchIP()
  useEffect(() => {
    if (typeof window === "undefined") return;

    const flag = sessionStorage.getItem("shouldFetchIPAfterReload");
    if (flag) {
      sessionStorage.removeItem("shouldFetchIPAfterReload");
      fetchIPs();
    }
  }, []);
  return (
    <>
      <div className={styles.overlay}></div>
    {!openForm && !isRoute &&  <button className={styles.closeButton} onClick={CloseLogin}>
        x
      </button>}
      {!openForm && action === "" && <div className={isRoute? `${styles.container} ${styles.route}` : `${styles.container}`} >
        <div className={styles.header}>
          <div className={styles.title}>Login / Sign up</div>
          <div className={styles.desc}>Get access to the hottest events</div>
        </div>
        <div className={styles.way}>
          <button
            className={ByEmail ? {} : styles.selected}
            onClick={() => setByEmail(false)}
          >
            Phone Number
          </button>
          <button
            className={!ByEmail ? {} : styles.selected}
            onClick={() => setByEmail(true)}
          >
            Email
          </button>
        </div>
        {ByEmail ? (
          <LoginByEmail handleRetrieveData={handleRetrieveData} setStartingAccount={setStartingAccount}/>
        ) : (
          <LoginByPhone handleRetrieveData={handleRetrieveData} setStartingAccount={setStartingAccount}/>
        )}
      </div>}
      {openForm && <div className={styles.containerForm}><SurveyForm userId={userId} surveyId={surveRes.surveyID} handleForSubmit={handleForSubmit} handleSkip={handleSkip}/></div>}

      {action === "COMPLETE-PROFILE-DATA" && <Signup data={data} handleRetrieveData={handleRetrieveData} dataVerify={dataVerify} isRoute={isRoute}/>}
      {action === "VALIDATE-OTP" && <VerificationCode data={data} handleRetrieveData={handleRetrieveData} handleResendBack={handleResendBack} startingAccount={startingAccount} isRoute={isRoute}/>}
      {action === "SELECT-PHONE-METHOD" && <VerificationWay receivedData={data} phone={data.to} handleRetrieveData={handleRetrieveData} isRoute={isRoute}/>}
    </>
  );
}
